import { withdrawFundsCompany } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function withdrawFunds(destinationAccount) {
  try {
    const confirmation = window.confirm(
      translate("destination-account", {
        destinationAccount: `${destinationAccount}`,
      })
    );

    if (confirmation) {
      await withdrawFundsCompany({ destinationAccount });
      addContextLog("info", "withdrawFundsCompany", "process", {
        destinationAccount,
      });
      alert(translate("my-account-section.withdrawn-money"));
    }
  } catch (e) {
    logError(
      e,
      `Error to withdrawFunds with destination ${destinationAccount}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
